import claimEn from './claim/en.json';
import claimZhHant from './claim/zh-Hant.json';
import claimVi from './claim/vi.json';
import claimTh from './claim/th.json';

export default {
  en: claimEn,
  'zh-Hant': claimZhHant,
  vi: claimVi,
  th: claimTh,
};
